import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ImageSourceModule} from '@aztrix/components/image-source';
import {TranslatePipe} from '@aztrix/translate';
import {IconsModule} from '@aztrix/icons';

import {RowCellViewModule} from '../row-cell-view.module';
import {AgreementCellViewComponent} from './agreement-cell-view.component';
import {HelperPipesModule} from '@aztrix/helpers';

@NgModule({
  declarations: [AgreementCellViewComponent],
  imports: [
    CommonModule,
    HelperPipesModule,
    TranslatePipe,
    RowCellViewModule,
    IconsModule,
    ImageSourceModule,
  ],
  exports: [AgreementCellViewComponent],
})
export class AgreementCellViewModule {}
